<script>
import { mapGetters } from 'vuex'

import LikableMixin from '@src/mixins/likable.js'
import Translatable from '@src/mixins/translatable.js'

import FreeAttractionCard from '@components/attractions/free-attraction-card.vue'

import {Swiper, SwiperSlide} from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import _ from "underscore";

export default {
  components: {
    Swiper,
    SwiperSlide,
    FreeAttractionCard
  },
  mixins: [
    LikableMixin,
    Translatable
  ],
  data() {
    return {
      swiperOptions: {
        allowTouchMove: true,
        navigation: {
          nextEl: '.right-control',
          prevEl: '.left-control'
        },
        breakpoints: {
          320: {
            slidesPerView: 1.1,
            slidesPerGroup: 1.1,
            spaceBetween: 8,
          },
          450: {
            slidesPerView: 1.5,
            slidesPerGroup: 1.5,
            spaceBetween: 8,
          },
          600: {
            slidesPerView: 2,
            slidesPerGroup: 1.3,
            spaceBetween: 8,
          },
          768: {
            speed: 1300,
            slidesPerView: 4,
            slidesPerGroup: 3,
            spaceBetween: 20,
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters('attractions', [
      'freeEntryAttractions'
    ])
  },
  methods: {
    backgroundImage(attraction) {
      const img = _.sample(attraction.webimages)
      return {
        backgroundImage: `url(${process.env.VUE_APP_STATIC_URL}${img})`
      }
    },
  }
}
</script>

<template>
  <div class="carousel-container justify-center">
    <div v-if="freeEntryAttractions.length > 4" class="left-control"></div>
    <div class="container">
      <Swiper ref="attractionsSwiper" :options="swiperOptions">
        <SwiperSlide v-for="attraction in freeEntryAttractions" :key="attraction._id">
          <FreeAttractionCard :attraction="attraction"/>
        </SwiperSlide>
      </Swiper>
    </div>
    <div v-if="freeEntryAttractions.length > 4" class="right-control"></div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

::v-deep .swiper-wrapper,
.swiper-container {
  // we need the slider not to overlap the toggled dropdown menu
  z-index: auto;
}


.break {
  width: 100%;
}

.carousel-container {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-flow: row wrap;
  align-items: center;
}

.control-mixin {
  height: 24px;
  width: 14.83px;
  cursor: pointer;
}

.right-control,
.left-control {
  &.swiper-button-disabled {
    opacity: 0.2;
    cursor: default;
  }
}

@media only screen and (max-width: $screen-width-xs) {
  .right-control,
  .left-control {
    display: none;
  }

  .carousel-container {
    & .container {
      padding: 0 0 0 10px;
    }
  }

  .card-container {
    width: 290px;
    height: 204px;
  }
}

.left-control {
  @extend .control-mixin;
  margin-right: 20px;
  background: url("../../../assets/icons/left-arrow.svg");
}

.right-control {
  @extend .control-mixin;
  margin-left: 20px;
  background: url("../../../assets/icons/right-arrow.svg");
}

.card-benefit {
  position: absolute;
  right: 0;
  margin-top: 10px;
  width: auto;
  padding-left: 15px;
  padding-right: 15px;
  height: 23px;
  background: #51AE28;
  border-radius: 5px 0 0 5px;
}

.card-container {
  height: 204px;
  width: 100%;
}

.link {
  display: block;
  width: 100%;
  height: 100%;
}

@media only screen and (min-width: $screen-width-md) {
  .card-container {
    height: 204px;
  }
}

.card-container {
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  border-radius: 10px;
}

.card-footer-mixin {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  bottom: 0;
  width: 100%;
  background: rgba(37, 44, 62, 0.6);
  border-radius: 0 0 10px 10px;
}

.card-footer-content {
  display: flex;
  flex-direction: column;
}

.card-footer {
  @extend .card-footer-mixin;
  height: 60px;
}

.card-footer-expanded {
  @extend .card-footer-mixin;
  height: 100px;
}

.attraction-title {
  font-family: Open Sans Semibold, sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 130%;
  text-transform: uppercase;
  text-align: center;
  color: #FFFFFF;
}

.attraction-subtitle {
  width: 211px;
  height: 48px;

  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  color: #FFFFFF;
}

.benefit-text {
  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 23px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: $dark-blue;
}
</style>
